import React from 'react';

const Box = ({children,top}) => {

    return (
        <div className={`w-full px-0 admin-page-section ${!top ? "mt-6" : ""}`}>
            {children}
        </div>
    );
};

export default Box;